import { render, staticRenderFns } from "./GroupsModalForm.vue?vue&type=template&id=1785b843&"
import script from "./GroupsModalForm.vue?vue&type=script&lang=js&"
export * from "./GroupsModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports